import { render, staticRenderFns } from "./MiniStore.vue?vue&type=template&id=a3d323bc&"
import script from "./MiniStore.vue?vue&type=script&lang=js&"
export * from "./MiniStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports